var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_293694",
    "data-name": "Group 293694",
    transform: "translate(-277 -876)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Canvas",
    width: 18,
    height: 18,
    transform: "translate(277 876)",
    fill: "#ff13dc",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "S_Instagram_18_N",
    transform: "translate(277 876)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_178667",
    "data-name": "Path 178667",
    d: "M9,2.441c2.136,0,2.389.009,3.233.047a4.419,4.419,0,0,1,1.485.276,2.472,2.472,0,0,1,.92.6,2.472,2.472,0,0,1,.6.92,4.42,4.42,0,0,1,.276,1.485c.038.844.047,1.1.047,3.233s-.009,2.389-.047,3.233a4.42,4.42,0,0,1-.276,1.485,2.644,2.644,0,0,1-1.518,1.518,4.42,4.42,0,0,1-1.485.276c-.844.038-1.1.047-3.233.047s-2.389-.009-3.233-.047a4.42,4.42,0,0,1-1.485-.276,2.472,2.472,0,0,1-.92-.6,2.472,2.472,0,0,1-.6-.92,4.419,4.419,0,0,1-.276-1.485c-.038-.844-.047-1.1-.047-3.233s.009-2.389.047-3.233a4.419,4.419,0,0,1,.276-1.485,2.472,2.472,0,0,1,.6-.92,2.472,2.472,0,0,1,.92-.6,4.419,4.419,0,0,1,1.485-.276C6.611,2.45,6.864,2.441,9,2.441ZM9,1c-2.173,0-2.445.009-3.3.048a5.868,5.868,0,0,0-1.94.372,3.908,3.908,0,0,0-1.417.923A3.908,3.908,0,0,0,1.42,3.76,5.868,5.868,0,0,0,1.048,5.7C1.009,6.555,1,6.827,1,9s.009,2.445.048,3.3a5.868,5.868,0,0,0,.372,1.94,3.908,3.908,0,0,0,.923,1.417,3.909,3.909,0,0,0,1.417.923,5.868,5.868,0,0,0,1.942.372C6.555,16.991,6.827,17,9,17s2.445-.009,3.3-.048a5.868,5.868,0,0,0,1.942-.372,4.094,4.094,0,0,0,2.34-2.34,5.868,5.868,0,0,0,.372-1.942c.039-.853.048-1.125.048-3.3s-.009-2.445-.048-3.3A5.867,5.867,0,0,0,16.58,3.76a3.909,3.909,0,0,0-.923-1.417A3.908,3.908,0,0,0,14.24,1.42a5.868,5.868,0,0,0-1.94-.372C11.445,1.009,11.173,1,9,1Z",
    fill: "#222",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_178668",
    "data-name": "Path 178668",
    d: "M9,4.892a4.108,4.108,0,1,0,2.9,1.2A4.108,4.108,0,0,0,9,4.892Zm0,6.775a2.667,2.667,0,1,1,1.886-.781A2.667,2.667,0,0,1,9,11.667Z",
    fill: "#222",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_178669",
    "data-name": "Path 178669",
    d: "M13.27,5.69a.96.96,0,1,0-.96-.96A.96.96,0,0,0,13.27,5.69Z",
    fill: "#222"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/Instagram.153d922f3873842b01a9e1e2decc4b19.svg";
export { ForwardRef as ReactComponent };